import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const refreshTracking = (fulfillmentIdsOrFulfillmentPlanIds) => {
  const { fulfillmentIds = [], fulfillmentPlanIds = [] } = fulfillmentIdsOrFulfillmentPlanIds;
  // endpoint accepts either
  if (!fulfillmentIds.length && !fulfillmentPlanIds.length) {
    throw new Error('You must provide either fulfillmentPlanIds or fulfillmentIds');
  }
  const post = axios
    .post('/tracking/refreshStatus', fulfillmentIdsOrFulfillmentPlanIds)
    .then((response) => get(response, 'data', undefined));
  const post$ = from(post);
  return post$;
};
